import React, { useState } from "react";
import axios from "axios";
import { FaGoogle, FaFacebookF } from 'react-icons/fa';
import Header from '../HomePage/Header';
import Navbar from '../HomePage/Navbar';
import Footer from '../HomePage/Footer';
import HelpTrigger from '../HomePage/HelpTrigger';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './toastStyles.css'; // custom toast styles
import "./Auth.css";
import { useNavigate } from "react-router-dom";

const Signup = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobile: "",
    gender: "",
    password: ""
  });

   const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

// const handleSignup = async (e) => {
//   e.preventDefault();
//   try {
//     const res = await axios.post("https://spinelleapi.emedha.in/user/auth/api/signup", formData);
//     toast.success(res.data.message || "Signup successful");
//     navigate('/login');
//   } catch (err) {
//     console.error(err);
//     toast.error(err.response?.data?.message || "Signup failed");
//   }
// };


const handleSignup = async (e) => {
  e.preventDefault();

  const { password } = formData;

  // Password strength regex:
  const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{8,}$/;

  if (!passwordRegex.test(password)) {
    toast.error("Password must be at least 8 characters and include an uppercase letter, a number, and a special character.");
    return;
  }

  try {
    const res = await axios.post("https://spinelleapi.emedha.in/user/auth/api/signup", formData);
    toast.success(res.data.message || "Signup successful");
    navigate('/login');
  } catch (err) {
    console.error(err);
    toast.error(err.response?.data?.message || "Signup failed");
  }
};


  return (
    <>
      <Header />
      <Navbar />
      <div className="auth-container">
        <div className="auth-card">
          <h2 className="auth-title">Join the World of Spinelle</h2>
          <p className="auth-subtitle mt-1">Exclusive access to fine craftsmanship and timeless beauty.</p>
          <form onSubmit={handleSignup}>
            <input type="text" name="firstName" placeholder="First Name" required onChange={handleChange} />
            <input type="text" name="lastName" placeholder="Last Name" required onChange={handleChange} />
            <input type="email" name="email" placeholder="Email Address" required onChange={handleChange} />
            <input type="tel" name="mobile" placeholder="Mobile Number" required onChange={handleChange} />
            <select name="gender" required onChange={handleChange}>
              <option value="">Select Gender</option>
              <option value="Male">Male</option>
              <option value="Female">Female</option>
              <option value="others">Others</option>
            </select>
            <input type="password" name="password" placeholder="Create Password" required onChange={handleChange} />
            <button className="auth-btn" type="submit">Sign Up</button>
            <p className="auth-link">Already have an account? <a href="/login">Login</a></p>
          </form>

          <div className="social-login">
            <p>Or continue with</p>
            <div className="social-icons1">
              <button
                className="social-icon-reset"
                style={{
                  backgroundColor: '#DB4437',
                  color: '#fff',
                  border: 'none',
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  fontSize: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  cursor: 'pointer',
                }}
              >
                <FaGoogle />
              </button>

              <button
                className="social-icon-reset"
                style={{
                  backgroundColor: '#3b5998',
                  color: '#fff',
                  border: 'none',
                  width: '44px',
                  height: '44px',
                  borderRadius: '50%',
                  fontSize: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  cursor: 'pointer',
                }}
              >
                <FaFacebookF />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <HelpTrigger />
         <ToastContainer
  position="top-right"
  autoClose={4000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>

    </>
  );
};

export default Signup;
